<template>
  <div class="container">
    <div class="box chat-box is-fullheight" ref="chat_box">
      <div class="title is-4">{{ assistant.name }}</div>
      <div class="box p-4 mb-2">
        <article class="media">
          <div class="media-content">
            <div class="content">
              <p>
                {{ assistant.first_assistant_message }}
              </p>
            </div>
          </div>
        </article>
      </div>
      <div class="">
        <div
          class="box p-4 mb-2"
          v-for="(message, index) in chat_messages"
          :key="index"
          :class="{
            'has-text-right': message.role === 'user',
          }"
        >
          <article class="media">
            <div class="media-content">
              <div class="content">
                <p v-if="message.role == 'user'">
                  {{ message.content }}
                </p>
                <p v-else-if="message.role == 'assistant'">
                  <span v-html="message.content"></span>
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
      <div class="field has-addons">
        <div class="control is-expanded">
          <input
            v-model="new_message"
            @keyup.enter="send_message"
            class="input"
            type="text"
            placeholder="Escribe un mensaje..."
          />
        </div>
        <div class="control">
          <button @click="send_message" class="button is-primary">
            <span class="icon">
              <i class="fa fa-paper-plane"></i>
            </span>
            <span>{{ $t("send") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- </section> -->
</template>

<script>
import { get, post, error_message, api_host, warning_message } from "@/utils";
import { io } from "socket.io-client";

export default {
  data() {
    return {
      assistant: {},
      chat_messages: [],
      new_message: "",
      ready: false,
      socket: null,
    };
  },
  methods: {
    send_message() {
      let v = this;
      // v.$root.loader(true);
      if (!v.new_message) {
        warning_message(v.$t("please enter a message"));
        return;
      }

      let data = {
        prompt: v.new_message,
        personality_uuid: v.assistant.uuid,
        conversation_id: v.assistant.conversation_id,
        messages: v.chat_messages.filter((m) => m.automatic != true),
      };
      // console.log("data", data);
      v.socket.emit("assistant_live_chat", data);
      v.chat_messages.push({
        role: "user",
        content: v.new_message,
      });
      v.new_message = "";
      // // Clear the input field
      // this.userMessage = "";
      v.scroll_to_bottom();
    },
    scroll_to_bottom() {
      let v = this;
      let element = v.$refs.chat_box;
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
      // this.$nextTick(() => {
      //   const messages = this.$refs.messages;
      //   messages.scrollTop = messages.scrollHeight;
      // });
    },
    load_assistant() {
      let v = this;
      let api_key = v.$route.params.api_key;
      v.$root.loader(true);
      get("/assistant/external", { key: api_key })
        .then((response) => {
          v.assistant = response;
        })
        .catch((error) => {
          console.error("Error loading assistant:", error);
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    initialize_socket() {
      let v = this;
      // console.log("Initializing socket...", api_host);
      v.socket = io(api_host); // Replace with your server URL
      // console.log("Socket initialized");

      // Listen for incoming messages
      v.socket.on("assistant_live_chat", (message) => {
        // console.log("Received message:", message);
        v.chat_messages.push(message);
        v.scroll_to_bottom();
      });
      v.socket.on("assistant_chat_execution_result", (message) => {
        // console.log("Received message:", message);
        v.chat_messages.push({ ...message, automatic: true });
        v.scroll_to_bottom();
      });

      // Handle connection errors
      v.socket.on("connect_error", (error) => {
        console.error("Socket connection error:", error);
      });
    },
  },
  mounted() {
    let v = this;
    v.initialize_socket();
  },
  created() {
    let v = this;
    get("/system/settings", {})
      .then((r) => {
        localStorage.setItem("system_settings", JSON.stringify(r));
        if (r && r.free_use_urls)
          localStorage.setItem("permissions", JSON.stringify(r.free_use_urls));
        v.ready = true;
      })
      .catch((err) => {
        console.error(err);
        error_message(err);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
  watch: {
    ready(value) {
      if (value) {
        this.load_assistant();
      }
    },
  },
};
</script>

<style scoped>
.chat-box {
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.messages {
  flex-grow: 1;
  margin-bottom: 1rem;
  overflow-y: auto;
}

.message {
  margin-bottom: 0.5rem;
}

.message.is-user {
  text-align: right;
}

.message.is-user .message-body {
  background-color: #209cee;
  color: white;
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 8px;
}

.message.is-assistant .message-body {
  background-color: #00d1b2;
  color: black;
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 8px;
}
</style>
